import { percentageSignFilter } from "app/filters/ngFilters";
import FilterNewTag from "app/pages/sales-intelligence/common-components/filters-panel/components/FilterNewTag/FilterNewTag";
import createRangeSelectFilter from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/RangeSelectFilter/factory";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import { ConversionRateUpgradeView } from "../../components/filters/ConversionRateFilter/ConversionRateUpgradeView";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import leadsSearchFiltersI18nKeys from "../../utils/i18n";
import { defineDescriptionFilter } from "../defineSourcedFilter";

const FORMAT_DECIMAL_PLACE = 1;

export const conversionRateDefinition = defineDescriptionFilter({
    key: "conversionRate",
    apiCategory: leadsFilterApiCategory.conversionRate,
    category: leadsFilterCategoryMap.website,
    trackingName: "Conversion Rate",

    render: ({ description }) => {
        const showUpgrade = !salesSettingsHelper.isEcommConversionRateEnabled;
        const formatPercent = percentageSignFilter();

        return createRangeSelectFilter({
            key: "conversionRate",
            trackingName: "Conversion Rate",
            apiCategory: leadsFilterApiCategory.conversionRate,
            category: leadsFilterCategoryMap.website,
            visibility: showUpgrade ? "always-visible" : undefined,
            gateStatus: showUpgrade ? { type: "upgrade", view: ConversionRateUpgradeView } : undefined,
            tag: showUpgrade ? FilterNewTag : undefined,

            rangeOptions: {
                fieldName: "conversionRate",
                labelKey: leadsSearchFiltersI18nKeys.filterSummaryLabel("conversionRate"),
                buckets: description.bucketsDescription.conversionRate,
                formatValue: (v) => formatPercent(v, FORMAT_DECIMAL_PLACE),
            },
        });
    },
});
